import { Action } from "../actions/types"
import { RouteMasterType, RouteMasterActionList } from "../actions/routeMasterActions"

const initialValue: Array<RouteMasterType> = []

const routeMasterReducer = (state: Array<RouteMasterType> = initialValue, action: Action) => {
    switch (action.type) {

        case RouteMasterActionList.ADD_ROUTE_MASTER:
            return [
                ...state,
                action.data,
            ]

        case RouteMasterActionList.UPDATE_ROUTE_MASTER:
            const updated = [...state].slice()
            const index = updated.findIndex(u => u.id === action.data.id)

            if (index > -1) {
                updated[index] = {
                    ...action.data
                }
            }

            return updated

        case RouteMasterActionList.FETCH_ROUTE_MASTER:
            return action.data

        case RouteMasterActionList.DELETE_ROUTE_MASTER:
            return state.filter(s => s.id !== action.data)

        default:
            return state
    }
}

export default routeMasterReducer